<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item>
                        <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row :gutter="10" class="u-mb-15">
            <el-col :xs="24" :sm="24" :md="24">
                <el-input v-model="codigo" placeholder="Digite ou escaneie o código do exemplar e tecle ENTER" @keyup.native.enter="buscarEmprestimo" :clearable="true" :disabled="exibeSelectInstituicao && !filtro.instituicao.id">
                    <el-button slot="append" icon="el-icon-search" @click="buscarEmprestimo">Buscar</el-button>
                </el-input>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                <div class="u-mt-10">
                    <router-link to="/admin/biblioteca/emprestimo">
                        <el-button plain>Lista completa</el-button>
                    </router-link>
                </div>
            </el-col>
        </el-row>

        <div v-if="exibeSelectInstituicao && !filtro.instituicao.id" class="u-text-center u-mt-15" style="color:#909399">
            Selecione uma instituição para iniciar a devolução.
        </div>

        <div v-if="erroBusca" class="u-text-center u-mt-15" style="color:#F56C6C">{{ erroBusca }}</div>

        <div v-if="emprestimo" class="info-emprestimo u-mt-15">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    <p><strong>Livro:</strong> {{ (emprestimo.exemplar && emprestimo.exemplar.livro) ? emprestimo.exemplar.livro.titulo : '-' }}</p>
                    <p><strong>Autor:</strong> {{ (emprestimo.exemplar && emprestimo.exemplar.livro) ? emprestimo.exemplar.livro.autor : '-' }}</p>
                    <p><strong>Exemplar:</strong> #{{ emprestimo.exemplar ? emprestimo.exemplar.codigo : '-' }}</p>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    <p><strong>Leitor:</strong> {{ emprestimo.usuario_nome ? emprestimo.usuario_nome : ('#' + emprestimo.usuario_id) }} <small>({{ (emprestimo.usuario_tipo || '').toUpperCase() }})</small></p>
                    <p><strong>Empréstimo em:</strong> {{ formatDate(emprestimo.data_emprestimo) }}</p>
                    <p>
                        <strong>Prevista para:</strong> {{ formatDate(emprestimo.data_prevista_devolucao) }}
                        <span v-if="diasAtraso > 0" class="atraso">— atrasado em {{ diasAtraso }} dia(s)</span>
                    </p>
                </el-col>
            </el-row>

            <el-form @submit.native.prevent="confirmarDevolucao" :model="formDevolver" ref="formDevolver" label-position="top" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Data da devolução" prop="data_devolucao" :rules="[$requiredChange]">
                            <el-date-picker v-model="formDevolver.data_devolucao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Estado do exemplar" prop="estado_devolucao" :rules="[$requiredChange]">
                            <el-select v-model="formDevolver.estado_devolucao" style="width: 100%;">
                                <el-option label="DISPONÍVEL" value="disponivel"></el-option>
                                <el-option label="DANIFICADO" value="danificado"></el-option>
                                <el-option label="PERDIDO" value="perdido"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Multa (R$)" prop="multa_valor">
                            <el-input v-model="formDevolver.multa_valor" :placeholder="diasAtraso > 0 ? 'preencher manualmente se houver multa' : ''"></el-input>
                            <small class="u-text-muted">Cálculo manual.</small>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Observação" prop="observacao">
                            <el-input type="textarea" :rows="2" v-model="formDevolver.observacao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button @click="reset" plain>Limpar</el-button>
                        <el-button class="u-ml-10" type="primary" id="btn-confirmar-devolucao" native-type="submit">CONFIRMAR DEVOLUÇÃO</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <el-dialog title="Reservas pendentes" :visible.sync="dialogReservaVisible" width="500px" :close-on-click-modal="false">
            <div v-if="reservaPendente">
                <p>Existe uma reserva aguardando para este livro:</p>
                <p><strong>Leitor:</strong> {{ (reservaPendente.usuario_tipo || '').toUpperCase() }} #{{ reservaPendente.usuario_id }}</p>
                <p><strong>Validade da reserva:</strong> {{ formatDate(reservaPendente.data_validade) }}</p>
                <p>Deseja atender esta reserva agora?</p>
            </div>
            <div slot="footer" class="u-text-right">
                <el-button @click="dialogReservaVisible = false" plain>Não, depois</el-button>
                <router-link class="u-ml-10" :to="'/admin/biblioteca/reserva'">
                    <el-button type="primary">Ir para reservas</el-button>
                </router-link>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        codigo: '',
        emprestimo: null,
        diasAtraso: 0,
        erroBusca: '',
        formDevolver: {
            data_devolucao: '',
            estado_devolucao: 'disponivel',
            multa_valor: '',
            observacao: ''
        },
        dialogReservaVisible: false,
        reservaPendente: null,
        filtro: {
            instituicao: { id: '', nome: '' }
        }
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted(){
        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
    },
    methods: {
        async changeInstituicao(){
            if(this.exibeSelectInstituicao){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }
            this.reset();
        },
        buscarEmprestimo(){
            if(!this.codigo || !this.codigo.trim()){
                window.eventBus.$emit('alert', {msg: 'Informe o código do exemplar.', type: 'warning'});
                return;
            }
            this.erroBusca = '';
            this.emprestimo = null;
            this.diasAtraso = 0;
            window.eventBus.$emit('loading', true);

            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/emprestimo/getAbertoByExemplarCodigo`,
                { codigo: this.codigo.trim(), instituicao_id: instituicaoId },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                window.eventBus.$emit('loading', false);
                if(response.data && response.data.erro){
                    this.erroBusca = response.data.erro;
                    return;
                }
                this.emprestimo = response.data.emprestimo;
                this.diasAtraso = response.data.dias_atraso || 0;
                this.formDevolver.data_devolucao = this.$moment().format('YYYY-MM-DD');
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        confirmarDevolucao(){
            this.$refs.formDevolver.validate((valid) => { if(valid){
                document.getElementById('btn-confirmar-devolucao').focus();
                window.eventBus.$emit('loading', true);
                const livroId = (this.emprestimo.exemplar && this.emprestimo.exemplar.livro) ? this.emprestimo.exemplar.livro.id : null;
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/biblioteca/emprestimo/devolver/` + this.emprestimo.id,
                    this.formDevolver,
                    this.$store.getters.getHeaderAuth
                ).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível registrar a devolução.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Devolução registrada com sucesso.', type: 'success'});
                    if(livroId){
                        this.checarReservaPendente(livroId);
                    }
                    this.reset();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }});
        },
        checarReservaPendente(livroId){
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/biblioteca/reserva/getAllPaginate?page=1`,
                { livro_id: livroId, status: 'aguardando', instituicao_id: instituicaoId },
                this.$store.getters.getHeaderAuth
            ).then(response => {
                const data = (response.data && response.data.data) ? response.data.data : [];
                if(data.length > 0){
                    this.reservaPendente = data[0];
                    this.dialogReservaVisible = true;
                }
            }).catch(() => { /* silencioso — só sugestão */ });
        },
        reset(){
            this.codigo = '';
            this.emprestimo = null;
            this.diasAtraso = 0;
            this.erroBusca = '';
            this.formDevolver = {
                data_devolucao: '',
                estado_devolucao: 'disponivel',
                multa_valor: '',
                observacao: ''
            };
        },
        formatDate(d){
            if(!d) return '';
            return this.$moment(d).format('DD/MM/YYYY');
        }
    }
}
</script>

<style scoped>
.info-emprestimo{
    background: #f7f9fc;
    padding: 16px;
    border-radius: 6px;
}
.info-emprestimo p{ margin: 4px 0; }
.atraso{ color: #F56C6C; font-weight: 600; margin-left: 6px; }
</style>
